export default {
  label: "Alertas y Notificaciones",
  alerts: "Alertas",
  alertDefinitions: "Gestión de Alertas",
  scopeEdit: {
    operator: "Operador",
    value: "Valor",
    WarningScope: "Ámbito de Advertencia",
  },
  NotificationResubmissionInterval: {
    h1: "1 h",
    h6: "6 h",
    h12: "12 h",
    h24: "24 h",
    never: "Nunca",
  },
  createAlert: "Crear Alerta",
};
